module.exports = __webpack_public_path__ + "Flag-530.89d6475b27f31b51c1843d44ecc9330d.svg";